import { type ExternalResponse, type Response } from './get-product-info';

export default function adapter(externalResponse: ExternalResponse) {
  const response: Response = {
    data: {
      ...externalResponse.data,
      currentSeller: externalResponse.data.currentSeller ?? {
        id: '',
        assistedSalesScopes: {
          canConsultBatchSearch: false,
          canConsultStock: false,
          canPurchase: false,
        },
        ecommerceScopes: {
          canConsultEcommerceStock: false,
          canPickupInStore: false,
          canPurchase: false,
        },
        isFreeShipping: false,
        isOutlet: false,
        quantityLimitMessage: null,
        selected: false,
        shop: {
          id: '',
          logo: '',
          name: '',
        },
        skuInstance: null,
        pricing: externalResponse.data.product.pricing,
        isLMFreightActive: false,
      },
    },
  };

  return response;
}
